var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alternative-empty-table"},[_c('AttentionSign',{staticStyle:{"color":"red"}}),_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }